function removeProduct() {
  let updates = {
    41226791518231: 0,

    41226792468503: 0,

    41226792501271: 0,

    41226792534039: 0,

    41226792566807: 0,
  };

  fetch("/cart.js")
    .then((res) => res.json())

    .then((cart) => {
      let updates = {};

      cart.items.forEach((item) => {
        // Use the item's `key`, not variant ID

        if (
          [
            41226791518231, 41226792468503, 41226792501271, 41226792534039,
            41226792566807,
          ].includes(item.variant_id)
        ) {
          updates[item.key] = 0;
        }
      });

      return fetch("/cart/update.js", {
        method: "POST",

        headers: { "Content-Type": "application/json" },

        body: JSON.stringify({ updates }),
      });
    })

    .then((response) => response.json())

    .then((data) => {
      console.log("Cart updated:", data);
    })

    .catch((error) => {
      console.error("Error:", error);
    });
}
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    removeProduct();
  }
});
removeProduct();

var urlParams = new URLSearchParams(window.location.search);
var discountCode = urlParams.get("discount");

if (discountCode) {
  // Save the discount code as a session cookie
  document.cookie = `discount_code=${discountCode}; path=/`;

  // Send GET request to "/discount/[discountcode]"
  fetch(`/discount/${discountCode}`)
    .then(function () {
      // After the discount code has been applied, force the cart to update so the discount is visible for anything that calls the .cart.json file e.g. an AJAX draw cart.
      return fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {},
        }),
      });
    })
    .catch(function (error) {
      console.error("Error:", error);
    });
}

document.addEventListener("hc.hpCountdownLoaded", event =>{
  const hc_cd = event.detail.countdown;
  if (hc_cd.classList.contains("hc_cd_sticky")){
    const move_to = document.querySelector("#header");
    move_to.parentNode.insertBefore(hc_cd, move_to);
    hc_cd.classList.remove("hc_cd_sticky");
    document.body.style.marginTop=0;
  }
})
